export enum invoiceItemStatus {
  Pending = 'Pending',
  Matched = 'Matched',
  QuantityMismatch = 'QuantityMismatch',
  PriceMismatch = 'PriceMismatch',
  AwaitingCreditNote = 'AwaitingCreditNote',
  Accepted = 'Accepted',
  Failed = 'Failed'
}